import Dashboard from "../../pages/Dashboard";
import Login from "../../pages/Login";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import Redirect from "../../pages/Redirect";
import { ROLES } from "../../types/user.types";
import TotemVacuum from "../../pages/TotemVacuum";
import TotemWashing from "../../pages/TotemWashing";
import Notifications from "../../pages/Notifications";
import Sales from "../../pages/Sales";
import Customers from "../../pages/Customers";
import Fleets from "../../pages/Fleets";
import Vehicles from "../../pages/Vehicles";
import WashingOperator from "../../pages/WashingOperator";
import StartWashingMachine from "../../pages/StartWashingMachine/StartWashingMachine";
import StartVacuumCleaner from "../../pages/StartVacuumCleaner/StartVacuumCleaner";
import ScheduleSettings from "../../pages/ScheduleSettings";
import TotemLaundry from "../../pages/TotemLaundry";
import StartLaundryMachine from "../../pages/StartLaundryMachine/StartLaundryMachine";
import ResetWashingMachine from "../../pages/ResetWashingMachine/ResetWashingMachine";
import BalanceRequests from "../../pages/BalanceRequests";
import Coupons from "../../pages/Coupons";
import Devices from "../../pages/Devices/Devices";
import TestDevice from "../../pages/TestDevice/TestDevice";
import GasOrders from "../../pages/GasOrders";
import Printers from "../../pages/Printers/Printers";
import PendingPayments from "../../pages/PendingPayments";
import BlockedUsers from "../../pages/BlockedUsers";
import Feedbacks from "../../pages/Feedbacks";

export interface RouteMap {
  [key: string]: RouteType;
}
export interface RouteType {
  path: string;
  element: React.ReactElement | React.FC;
  title?: string;
  show?: boolean;
  authorizedRoles?: ROLES[];
}

export const publicRoutes: RouteMap = {
  default: {
    path: "/",
    element: Login
  },
  login: {
    path: "/login",
    element: Login
  },
  redirect: {
    path: "/redirect",
    element: Redirect
  },
  dashboard: {
    path: "/dashboard",
    element: Dashboard
  },
  privacyPolicy: {
    path: "/privacy-policy",
    element: PrivacyPolicy
  },
  startWashingMachine: {
    path: "/start-washing-machine",
    element: StartWashingMachine
  },
  resetWashingMachine: {
    path: "/reset-washing-machine",
    element: ResetWashingMachine
  },
  startVacuumCleaner: {
    path: "/start-vacuum-cleaner",
    element: StartVacuumCleaner
  },
  startLaundryMachine: {
    path: "/start-laundry-machine",
    element: StartLaundryMachine
  },
  totemVacuum: {
    path: "/totem/vacuum",
    element: TotemVacuum
  },
  totemWashing: {
    path: "/totem/washing",
    element: TotemWashing
  },
  totemLaundry: {
    path: "/totem/laundry",
    element: TotemLaundry
  },
  testDevice: {
    path: "/test-device",
    element: TestDevice
  }

}

export const privateRoutes: RouteMap = {
  sales: {
    title: "Vendas",
    path: "/sales",
    show: true,
    authorizedRoles: [ROLES.ANY],
    element: Sales
  },
  notifications: {
    title: "Notificações",
    path: "/notifications",
    show: false,
    authorizedRoles: [ROLES.ADMIN],
    element: Notifications
  },
  coupons: {
    title: "Cupons",
    path: "/coupons",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Coupons
  },
  customers: {
    title: "Clientes",
    path: "/customers",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Customers
  },
  fleets: {
    title: "Frotas",
    path: "/fleets",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Fleets
  },
  vehicles: {
    title: "Veículos",
    path: "/vehicles",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Vehicles
  },
  washingOperator: {
    title: "Operador Lavação",
    path: "/washing-operator",
    show: false,
    authorizedRoles: [ROLES.ADMIN, ROLES.OPERATOR],
    element: WashingOperator
  },
  scheduleSettings: {
    title: "Agendamento",
    path: "/schedule-settings",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: ScheduleSettings
  },
  balanceRequests: {
    title: "Consultas Restantes",
    path: "/balance-requests",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: BalanceRequests
  },
  printers: {
    title: "Impressoras",
    path: "/printers",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Printers
  },
  testDevice: {
    title: "Dispositivos",
    path: "/devices",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Devices
  },
  gasOrders: {
    title: "Abastecimentos",
    path: "/gas-orders",
    show: true,
    authorizedRoles: [ROLES.ANY],
    element: GasOrders
  },
  pendingPayments: {
    title: "Pag. Pendentes",
    path: "/pending-payments",
    show: true,
    authorizedRoles: [ROLES.ANY],
    element: PendingPayments
  },
  blockedUsers: {
    title: "Usuários bloqueados",
    path: "/blocked-users",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: BlockedUsers
  },
  feedbacks: {
    title: "Feedbacks",
    path: "/feedbacks",
    show: true,
    authorizedRoles: [ROLES.ADMIN],
    element: Feedbacks
  },
  dashboard: {
    title: "Dashboard",
    path: "/dashboard?station=Z7&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJtcy1wZWRpZG9zIiwic3ViIjoidGVzdGUiLCJ1c2VySWQiOiI2N2QyZTlhNjliODRhZDY3MWY2NWJkOTkiLCJleHAiOjIyMDg5OTk2MDB9.tQCWcSJTSmq0pL1Rw1jK3hAr6emJ2z7mYK0-Wwk0Z-g",
    show: true,
    authorizedRoles: [ROLES.ADMIN, ROLES.VIEWER],
    element: Dashboard
  },
};